<div class="custom-carousel-wrapper">
  <owl-carousel-o [options]="options">
    <ng-container *ngFor="let image of images; let index = index">
      <ng-template carouselSlide [id]="index">
        <img class="carousel-image" [src]="image" />
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>
